import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";

export const makeService = ({ connection }: ApiSliceParams) => {
    const {
        allLoading: loading,
        allLoaded: loaded,
        items: services,
        listen,
    } = createListController({
        connection,
        list: (con) => con.service.items({}),
    });

    const enabled = (service: string, method: string) =>
        services.value.some(
            (s) => s.service === `${service}Service` && s.method === method,
        );

    const enabledPeek = (service: string, method: string) =>
        services
            .peek()
            .some(
                (s) => s.service === `${service}Service` && s.method === method,
            );

    return { services, loading, loaded, listen, enabled, enabledPeek };
};
